'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ReoptimizationService = function ReoptimizationService(restangular, momentService, configurationService, RsqlQuery, $log, scenarioService, scenarioConstants, $rootScope, reoptPreviewDataUtilsService, searchCriteriaRsqlQueryService, userActionService, userSecureService) {
  var PRODUCTION_SCENARIO_NAME = scenarioConstants.PUBLISHED;
  var flightsService = restangular.one('domain').one('flights');
  var marketService = restangular.one('domain').one('marketdemand');
  var service = restangular.service('domain/flights/reoptimization');
  var reoptimizationFlightService = restangular.service('domain/flights/reoptimization/flight');
  var reoptimizationFaresService = restangular.service('domain/faresoptimizer/reoptimization/fares');
  var reoptimizationMarketService = restangular.service('domain/marketdemand/reoptimization/market');
  var cabinFlightService = restangular.one('domain').one('flights').all('flattenedLegCabins');
  var classFlightService = restangular.one('domain').one('flights').all('mergedlegclasssegclass');
  var flightSummaryService = restangular.one('domain').one('flights').all('flattenedFlightSummary');
  var marketDemandClassGroupService = restangular.one('domain').one('marketdemand').all('flattenedMarketDemandClassGroupPOS');
  var marketDemandService = restangular.one('domain').one('marketdemand').all('flattenedMarketDemandPOS');
  var marketServicesService = restangular.one('domain').one('services').all('flattenedServiceClassPOS');
  var segmentFlightService = restangular.one('domain').one('flights').all('flattenedSegmentClasses');
  var ndReoptPreviewService = flightsService.one('preview');
  var mdReoptPreviewService = marketService.one('preview');
  function sendRequest(requestParams) {
    return service.post(requestParams).then(function (res) {
      toastr.success('Optimization request submitted');
      return res;
    })["catch"](function () {
      $log.error('ReoptimizationService: sendRequest - Optimization request failed');
      toastr.error('Optimization request failed');
    });
  }
  function reoptimize(rows, optGroupDateField, scenarioName, carrier) {
    var queueElements = [];
    rows.forEach(function (row) {
      var queueElement = {
        optGroupDate: momentService.copy(row[optGroupDateField], momentService.FIELD.OPT_GROUP_DATE).toISOString(),
        carrier: carrier !== undefined ? carrier : row.carrier,
        scenarioName: scenarioName
      };
      if (!_.find(queueElements, queueElement)) {
        queueElements.push(queueElement);
      }
    });
    return sendRequest({
      queueElements: queueElements
    });
  }
  function sendNDOrMDRequest(requestParams, previewRequested, requestType, service) {
    var getParams = !previewRequested ? {
      priority: 10
    } : {};
    return service.post(requestParams, getParams).then(function (res) {
      if (requestParams.queueElements.length === res.length) {
        toastr.success(previewRequested ? 'Preview request submitted' : 'Optimization request submitted');
        return res;
      } else {
        toastr.warning(previewRequested ? 'Preview request is already submitted' : 'Optimization request is already submitted');
      }
    })["catch"](function () {
      $log.error('ReoptimizationService: ' + requestType + ' - ' + previewRequested ? 'Preview request failed' : 'Optimization request failed');
      toastr.error(previewRequested ? 'Preview request failed' : 'Optimization request failed');
    });
  }
  function transformScenarioName(scenarioName) {
    var createdBy = configurationService.getUserId();
    return scenarioName !== PRODUCTION_SCENARIO_NAME ? createdBy + '_' + scenarioName : scenarioName;
  }
  function reoptimizeND(rows, sendRequested, scenarioName, previewRequested) {
    var queueElements = [];
    var scenarioNameWithPrefix = transformScenarioName(scenarioName);
    rows.forEach(function (row) {
      var queueElement = {
        carrier: row.carrier,
        optGroupDate: row.optGroupDateMoment !== undefined ? momentService.copy(row.optGroupDateMoment, momentService.FIELD.OPT_GROUP_DATE).toISOString() : '',
        scenarioName: scenarioNameWithPrefix,
        number: row.flightNumber,
        opsSuffix: row.opsSuffix,
        departureDate: momentService.copy(row.flightDepartureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString(),
        sendRequested: sendRequested
      };
      if (!_.find(queueElements, queueElement)) {
        queueElements.push(queueElement);
      }
    });
    return sendNDOrMDRequest({
      queueElements: queueElements
    }, previewRequested, 'ND', reoptimizationFlightService);
  }
  function reoptimizeMD(rows, scenarioName, previewRequested) {
    var queueElements = [];
    var scenarioNameWithPrefix = transformScenarioName(scenarioName || PRODUCTION_SCENARIO_NAME);
    rows.forEach(function (row) {
      var queueElement = {
        carrier: row.carrier,
        departureDate: row.departureDate ? row.departureDate : row.flightDepartureDateMoment.format(momentService.FIELD.MD_DEPARTURE_DATE.format),
        origin: getMarketOrigin(row.market ? row.market : row.leg),
        destination: getMarketDestination(row.market ? row.market : row.leg),
        scenarioName: scenarioNameWithPrefix
      };
      if (!_.find(queueElements, queueElement)) {
        queueElements.push(queueElement);
      }
    });
    return sendNDOrMDRequest({
      queueElements: queueElements
    }, previewRequested, 'MD', reoptimizationMarketService);
  }
  function populateReverseDirectionMarketForAdaptive(row) {
    if (row.adaptivePricingReoptCategory === 'ADAPTIVE') {
      row.market = row.market.split(',').flatMap(function (market) {
        return [market, market.split('-').reverse().join('-')];
      }).join(',');
    }
  }
  function reoptimizeFares(rows, carrier) {
    var queueElements = [];
    var mainCarrier = configurationService.getHostCarrier();
    var adaptiveRunNumber = configurationService.getAdaptiveRunNumber();
    var adaptiveCutOffTime = configurationService.getAdaptiveCutOffTime();
    rows.forEach(function (row) {
      populateReverseDirectionMarketForAdaptive(row);
      var markets = row.market.split(',');
      var cabins = row.adaptivePricingReoptCategory === 'ADAPTIVE' ? [row.foCabin] : row.foCabin.split(',');
      var queueElement = {
        carrier: row.processingCarrier,
        pos: row.pos,
        mainCarrier: mainCarrier,
        adaptiveCutOffTime: row.adaptivePricingReoptCategory === 'ADAPTIVE' ? adaptiveCutOffTime : '',
        adaptiveRunNumber: row.adaptivePricingReoptCategory === 'ADAPTIVE' ? adaptiveRunNumber : '',
        category: row.adaptivePricingReoptCategory === undefined ? 'STRUCTURAL/TACTICAL' : row.adaptivePricingReoptCategory
      };
      markets.forEach(function (market) {
        var queueElementWithMarket = _.cloneDeep(queueElement);
        queueElementWithMarket.origin = getMarketOrigin(market);
        queueElementWithMarket.destination = getMarketDestination(market);
        cabins.forEach(function (cabin) {
          var queueElementWithCabin = _.cloneDeep(queueElementWithMarket);
          queueElementWithCabin.cabin = cabin;
          if (!_.find(queueElements, queueElementWithCabin)) {
            queueElements.push(queueElementWithCabin);
          }
        });
      });
    });
    return sendFaresReoptRequest({
      queueElements: queueElements
    }, reoptimizationFaresService);
  }
  function sendFaresReoptRequest(requestParams, service) {
    return service.post(requestParams).then(function (res) {
      toastr.success('Optimization request submitted');
      return res;
    })["catch"](function () {
      $log.error('ReoptimizationService: Optimization request failed');
      toastr.error('Optimization request failed');
    });
  }
  function reoptimizeFromMarketScreen(rows, scenarioName) {
    return reoptimize(rows, 'departureDateMoment', scenarioName || PRODUCTION_SCENARIO_NAME);
  }
  function reoptimizeFromFlightScreen(rows, scenarioName) {
    return reoptimize(rows, 'optGroupDateMoment', scenarioName || PRODUCTION_SCENARIO_NAME);
  }
  function reoptimizeFromStatusScreen(rows) {
    return reoptimize(rows, 'optGroupDateMoment', PRODUCTION_SCENARIO_NAME, configurationService.getHostCarrier());
  }
  function reoptimizeFaresFromStatusScreen(rows) {
    return reoptimizeFares(rows, configurationService.getHostCarrier());
  }
  function reoptimizeNDFromFlightScreen(rows, scenarioName, sendRequested, previewRequested) {
    userActionService.saveUserAction('FLIGHT', _.map(rows, 'flightId'), 'REOPT');
    return reoptimizeND(rows, sendRequested, scenarioName || PRODUCTION_SCENARIO_NAME, previewRequested);
  }
  function showError(e, message) {
    $log.error('ReoptimizationService - ' + message + appendDataDetails(e.data));
    toastr.error(message);
  }
  function appendDataDetails(data) {
    return _.isObject(data) ? ', HTTP error code: ' + data.code + ', message: ' + data.message : '';
  }
  function undoNdReoptScenario(reoptPreviewData) {
    reoptPreviewDataUtilsService.resetNdReoptPreview(reoptPreviewData);
    return ndReoptPreviewService.remove({
      noSpinner: true
    }, {
      createdBy: configurationService.getUserId()
    });
  }
  function undoMdReoptScenario(reoptPreviewData) {
    reoptPreviewDataUtilsService.resetMdReoptPreview(reoptPreviewData);
    return mdReoptPreviewService.remove({
      noSpinner: true
    }, {
      createdBy: configurationService.getUserId()
    });
  }
  function resetReoptPreviewMode(reoptPreviewData) {
    if (userSecureService.hasAuthorization('flight-analysis', 'write')) {
      undoMdReoptScenario(reoptPreviewData);
      undoNdReoptScenario(reoptPreviewData);
    }
  }
  function flightFilterBuilder(row) {
    var rsqlQuery = new RsqlQuery();
    return rsqlQuery.is('flightId').equalTo(row.flightId).and().is('scenarioName').equalTo(scenarioService.getCurrentUserNDPreviewRequestName()).and().is('createdBy').equalTo(configurationService.getUserId());
  }
  function flightSummaryFilterBuilder(row, scenarioName) {
    var rsqlQuery = new RsqlQuery();
    return rsqlQuery.is('number').equalTo([row.flightNumber]).and().is('scenarioName').equalTo(scenarioName || scenarioService.getCurrentUserNDPreviewRequestName()).and().is('numberDepartureDate').equalTo(row.flightDepartureDateMoment.toISOString());
  }
  function marketDemandOrServicesFilterBuilder(row) {
    var rsqlQuery = new RsqlQuery();
    return rsqlQuery.is('origin').equalTo(row.origin).and().is('destination').equalTo(row.destination).and().is('departureDate').equalTo(row.departureDate).and().is('scenarioName').equalTo(scenarioService.getCurrentUserMDPreviewRequestName()).and().is('createdBy').equalTo(configurationService.getUserId());
  }
  function createRequestFilterParams(optimizedRows, filterBuilder, query, scenarioName) {
    _.forEach(optimizedRows, function (row, index) {
      var filterConditions = '(' + filterBuilder(row, scenarioName).query() + ')';
      if (optimizedRows.length - 1 !== index) {
        filterConditions = filterConditions + ',';
      }
      query = query + filterConditions;
    });
    return query + ')';
  }
  function createRequestParams(optimizedRows) {
    return createRequestFilterParams(optimizedRows, flightFilterBuilder, '?postDepartureMode=false&dataDepth=DEEP&sortCriteria=null&pageLimit=1000&filter=(');
  }
  function createFlightSummaryRequestParams(optimizedRows, scenarioName) {
    return createRequestFilterParams(optimizedRows, flightSummaryFilterBuilder, '?filter=(', scenarioName);
  }
  function createMarketAnalysisRequestParams(optimizedRows) {
    return createRequestFilterParams(optimizedRows, marketDemandOrServicesFilterBuilder, '?sortCriteria=null&pageLimit=-1&filter=(');
  }
  function createMarketServicesRequestParamsFromServiceIds(reoptPreviewData) {
    var serviceIdRsql = searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(reoptPreviewDataUtilsService.getServiceIdsSearchCriteriaRule(reoptPreviewData));
    var rsqlQuery = new RsqlQuery();
    var scenarioRsql = rsqlQuery.is('scenarioName').equalTo(scenarioService.getCurrentUserMDPreviewRequestName()).and().is('createdBy').equalTo(configurationService.getUserId()).query();
    return '?filter=(' + serviceIdRsql + ';' + scenarioRsql + ')';
  }
  function createMarketServicesRequestParams(optimizedRows, reoptPreviewData) {
    if (reoptPreviewData && reoptPreviewDataUtilsService.getServiceIdsSearchCriteriaRule(reoptPreviewData)) {
      return createMarketServicesRequestParamsFromServiceIds(reoptPreviewData);
    } else {
      return createRequestFilterParams(optimizedRows, marketDemandOrServicesFilterBuilder, '?dataDepth=SHALLOW&pageLimit=-1&filter=(');
    }
  }
  function createMDRequestParams() {
    var rsqlQuery = new RsqlQuery();
    var query = rsqlQuery.is('scenarioName').equalTo(scenarioService.getCurrentUserMDPreviewRequestName()).and().is('createdBy').equalTo(configurationService.getUserId()).query();
    return '?postDepartureMode=false&dataDepth=DEEP&sortCriteria=null&pageLimit=1000&filter=(' + query + ')';
  }
  function getRequestParams(optimizedRows) {
    if (optimizedRows) {
      return createRequestParams(optimizedRows);
    } else {
      return createMDRequestParams();
    }
  }
  function getFlightSummary(optimizedRows, scenarioName) {
    return flightSummaryService.get(createFlightSummaryRequestParams(optimizedRows, scenarioName))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getLegCabins(optimizedRows) {
    return cabinFlightService.get(getRequestParams(optimizedRows))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getLegClasses(optimizedRows) {
    return classFlightService.get(getRequestParams(optimizedRows))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getSegmentClasses(optimizedRows) {
    return segmentFlightService.get(getRequestParams(optimizedRows))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getMarketOrigin(market) {
    return market.split('-')[0];
  }
  function getMarketDestination(market) {
    return market.split('-')[1];
  }
  function getStatus(departureDate, flightNumber, previewScenarioName) {
    var partOfKey = previewScenarioName + ':' + flightNumber + '[' + departureDate + ']';
    var rsqlQuery = new RsqlQuery();
    var query = rsqlQuery.is('key').contains(_.escapeRegExp(partOfKey)).and().is('events[].userName').equalTo(configurationService.getUserId()).query();
    return restangular.one('queue').one('BomNDRequest').one('messages').one('bomQueue').get({
      filter: query,
      noSpinner: true
    });
  }
  function getMDStatus(departureDate, market, previewScenarioName) {
    var partOfKey = getMarketOrigin(market) + '.[' + departureDate + '].' + getMarketDestination(market) + '.' + previewScenarioName;
    var rsqlQuery = new RsqlQuery();
    var query = rsqlQuery.is('key').contains(_.escapeRegExp(partOfKey)).and().is('events[].userName').equalTo(configurationService.getUserId()).query();
    return restangular.one('queue').one('BomMDRequest').one('messages').one('bomQueue').get({
      filter: query,
      noSpinner: true
    });
  }
  function getMarketDemandClassGroups(optimizedRows) {
    return marketDemandClassGroupService.get(createMarketAnalysisRequestParams(optimizedRows))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getMarketDemand(optimizedRows) {
    return marketDemandService.get(createMarketAnalysisRequestParams(optimizedRows))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function getMarketServices(optimizedRows, gridId, reoptPreviewData) {
    return marketServicesService.get(createMarketServicesRequestParams(optimizedRows, reoptPreviewData))["catch"](function (e) {
      showError(e, 'Error occurred');
    });
  }
  function undoMdReoptAndReload(reoptPreviewData) {
    return undoMdReoptScenario(reoptPreviewData).then(function () {
      $rootScope.$broadcast('re-opt:undo-finished');
    });
  }
  return {
    PRODUCTION_SCENARIO_NAME: PRODUCTION_SCENARIO_NAME,
    reoptimizeFromFlightScreen: reoptimizeFromFlightScreen,
    reoptimizeFromMarketScreen: reoptimizeFromMarketScreen,
    reoptimizeFromStatusScreen: reoptimizeFromStatusScreen,
    reoptimizeNDFromFlightScreen: reoptimizeNDFromFlightScreen,
    reoptimizeMD: reoptimizeMD,
    reoptimizeFaresFromStatusScreen: reoptimizeFaresFromStatusScreen,
    getLegCabins: getLegCabins,
    getLegClasses: getLegClasses,
    getSegmentClasses: getSegmentClasses,
    getStatus: getStatus,
    getMDStatus: getMDStatus,
    undoNdReoptScenario: undoNdReoptScenario,
    undoMdReoptScenario: undoMdReoptScenario,
    getMarketDemandClassGroups: getMarketDemandClassGroups,
    getMarketDemand: getMarketDemand,
    getMarketServices: getMarketServices,
    undoMdReoptAndReload: undoMdReoptAndReload,
    getFlightSummary: getFlightSummary,
    resetReoptPreviewMode: resetReoptPreviewMode
  };
};
ReoptimizationService.$inject = ['Restangular', 'MomentService', 'ConfigurationService', 'RsqlQueryFactory', '$log', 'ScenarioService', 'ScenarioConstants', '$rootScope', 'ReoptPreviewDataUtilsService', 'SearchCriteriaRsqlQueryService', 'UserActionService', 'UserSecureService'];
module.exports = ReoptimizationService;